export const APP_NAME = import.meta.env.VITE_APP_NAME;

export const PUBLIC_URL = "";

export const PAYLOAD_URL = import.meta.env.VITE_PAYLOAD_URL;
export const IMAGE_HOST_URL = import.meta.env.VITE_IMAGE_HOST;

export const BASE_URL = import.meta.env.VITE_BASE_URL;
export const FRONTEND_URL = `${BASE_URL}/app`;
export const WEBSITE_URL = import.meta.env.VITE_WEBSITE_URL;

export const PAGINATION_LIMIT = 10;

export const PICKABLE_DATA_TYPES = [
  { label: "General Information", value: "text" },
  { label: "Date", value: "date" },
  { label: "Phone Number", value: "phone-number" },
  { label: "Email", value: "email" },
  { label: "URL", value: "url" },
  { label: "Address", value: "address" },
];

export const ALLOWED_IMAGE_TYPES_MIMES = {
  "image/jpeg": [],
  "image/png": [],
  "image/gif": [],
};

export const PICKABLE_INVOICE_CATEGORIES = [
  { label: "Rent", value: "rent" },
  { label: "Utility", value: "utility" },
  { label: "Fees", value: "fee" },
  { label: "Repair", value: "repair" },
  { label: "Maintenance", value: "maintenance" },
  { label: "Tax", value: "tax" },
  { label: "Other", value: "other" },
];

export const ALLOW_IMAGE_TYPES_EXT = ["jpg", "png", "svg", "gif"];

export const PICKABLE_LEASE_STATUSES = [
  { label: "Active", value: "active" },
  { label: "Draft", value: "draft" },
  { label: "Past", value: "past" },
  { label: "Upcoming", value: "upcoming" },
];

export const PICKABLE_DOCUMENT_TYPES = [
  { label: "Lease", value: "lease" },
  { label: "Invoice", value: "invoice" },
  { label: "Receipt", value: "receipt" },
  { label: "Utility", value: "utility" },
  { label: "Tax", value: "tax" },
  { label: "Image", value: "image" },
  { label: "Other", value: "other" },
];

export const ADDRESS_STATE_OPTIONS = [
  { label: "Alabama", value: "AL" },
  { label: "Alaska", value: "AK" },
  { label: "Arizona", value: "AZ" },
  { label: "Arkansas", value: "AR" },
  { label: "California", value: "CA" },
  { label: "Colorado", value: "CO" },
  { label: "Connecticut", value: "CT" },
  { label: "Delaware", value: "DE" },
  { label: "District of Columbia", value: "DC" },
  { label: "Florida", value: "FL" },
  { label: "Georgia", value: "GA" },
  { label: "Hawaii", value: "HI" },
  { label: "Idaho", value: "ID" },
  { label: "Illinois", value: "IL" },
  { label: "Indiana", value: "IN" },
  { label: "Iowa", value: "IA" },
  { label: "Kansas", value: "KS" },
  { label: "Kentucky", value: "KY" },
  { label: "Louisiana", value: "LA" },
  { label: "Maine", value: "ME" },
  { label: "Maryland", value: "MD" },
  { label: "Massachusetts", value: "MA" },
  { label: "Michigan", value: "MI" },
  { label: "Minnesota", value: "MN" },
  { label: "Mississippi", value: "MS" },
  { label: "Missouri", value: "MO" },
  { label: "Montana", value: "MT" },
  { label: "Nebraska", value: "NE" },
  { label: "Nevada", value: "NV" },
  { label: "New Hampshire", value: "NH" },
  { label: "New Jersey", value: "NJ" },
  { label: "New Mexico", value: "NM" },
  { label: "New York", value: "NY" },
  { label: "North Carolina", value: "NC" },
  { label: "North Dakota", value: "ND" },
  { label: "Ohio", value: "OH" },
  { label: "Oklahoma", value: "OK" },
  { label: "Oregon", value: "OR" },
  { label: "Pennsylvania", value: "PA" },
  { label: "Rhode Island", value: "RI" },
  { label: "South Carolina", value: "SC" },
  { label: "South Dakota", value: "SD" },
  { label: "Tennessee", value: "TN" },
  { label: "Texas", value: "TX" },
  { label: "Utah", value: "UT" },
  { label: "Vermont", value: "VT" },
  { label: "Virginia", value: "VA" },
  { label: "Washington", value: "WA" },
  { label: "West Virginia", value: "WV" },
  { label: "Wisconsin", value: "WI" },
  { label: "Wyoming", value: "WY" },
];

export const EXPENSE_CATEGORIES = [
  { label: "Advertising", value: "advertising" },
  { label: "Auto Travel", value: "auto-travel" },
  { label: "Cleaning & Maintenance", value: "cleaning-maintenance" },
  { label: "Commissions", value: "commissions" },
  { label: "Insurance", value: "insurance" },
  { label: "Legal", value: "legal" },
  { label: "Management", value: "management" },
  { label: "Mortgage Interest", value: "mortgage-interest" },
  { label: "Interest", value: "interest" },
  { label: "Repairs", value: "repairs" },
  { label: "Supplies", value: "supplies" },
  { label: "Taxes", value: "taxes" },
  { label: "Utilities", value: "utilities" },
  { label: "Depreciation", value: "depreciation" },
  { label: "Other", value: "other" },
];

export const PICKABLE_WEBSITE_STOCK_IMAGES = [
  {
    thumbUrl: "/app/assets/images/business-website/thumb/1.png",
    fullUrl: "/app/assets/images/business-website/full/1.png",
    value: 1,
    alt: "Modern dining room with a round wooden table and curved wooden chairs. Above the table are three white pendant lamps hanging from the ceiling. On the back wall, there are wooden shelves displaying decorative items like books and a bowl. The flooring appears to be a patterned carpet, adding visual interest and texture to the space. The overall aesthetic is contemporary and minimalist, with a focus on natural materials and clean lines.",
  },
  {
    thumbUrl: "/app/assets/images/business-website/thumb/2.png",
    fullUrl: "/app/assets/images/business-website/full/2.png",
    value: 2,
    alt: "Modern, high-end kitchen with white cabinetry, a large center island, and stainless steel appliances. The kitchen island features a white countertop and serves as a focal point with seating for two. Recessed lighting illuminates the space from above, while a stylish linear pendant light hangs over the island. Open shelving displays dishes and glassware, adding a decorative touch. The flooring appears to be hardwood, bringing warmth to the otherwise cool and crisp color palette. A small potted plant on the island adds a touch of natural greenery to the sleek, contemporary design.",
  },
  {
    thumbUrl: "/app/assets/images/business-website/thumb/3.png",
    fullUrl: "/app/assets/images/business-website/full/3.png",
    value: 3,
    alt: "Luxurious, eclectic living room with an elegant mix of furniture and decorative elements. Two velvet sofas in a light color are paired with dark wooden armchairs, creating an inviting seating arrangement. A glass coffee table sits atop a patterned blue area rug, adding visual interest to the hardwood flooring. The walls are adorned with an array of framed photographs and artwork, giving the space a curated, gallery-like feel. Large pendant lights hang from the ceiling, providing a warm ambiance. Decorative items such as pineapple-shaped objects and ceramic vases contribute to the room's sophisticated, collected aesthetic. The overall design seamlessly blends traditional and contemporary elements, resulting in a stylish and comfortable living space.",
  },
  {
    thumbUrl: "/app/assets/images/business-website/thumb/4.png",
    fullUrl: "/app/assets/images/business-website/full/4.png",
    value: 4,
    alt: "Sophisticated and luxurious living room with a dramatic, moody color palette. The room features two tufted, light blue armchairs and an ottoman, creating a cozy seating area. The chairs are adorned with plush fur pillows, adding a touch of texture and comfort. A patterned area rug in black, white, and gray ties the seating arrangement together. The dark walls are complemented by heavy, patterned curtains, contributing to the room's rich, intimate atmosphere. A tall, golden shelving unit displays decorative items and frames, while a potted plant adds a hint of natural greenery. The overall design exudes an air of opulence and refinement, with a carefully curated mix of colors, textures, and decorative elements.",
  },
  {
    thumbUrl: "/app/assets/images/business-website/thumb/5.png",
    fullUrl: "/app/assets/images/business-website/full/5.png",
    value: 5,
    alt: "Bright and airy dining area with a rustic, organic feel. A long wooden table takes center stage, accompanied by modern white chairs. The exposed brick wall adds texture and character to the space, while large windows allow ample natural light to flood the room. Pendant lights hang from the ceiling, providing additional illumination. A collection of green apples and succulents serve as a simple, natural centerpiece on the table, bringing a touch of freshness and color to the otherwise neutral palette. A blue teapot and other decorative elements on the table contribute to the room's inviting, lived-in atmosphere. The overall design creates a warm and welcoming space that seamlessly blends rustic and contemporary elements.",
  },
  {
    thumbUrl: "/app/assets/images/business-website/thumb/6.png",
    fullUrl: "/app/assets/images/business-website/full/6.png",
    value: 6,
    alt: "Modern, luxurious dining room interior. The focal point is a round, dark wooden dining table surrounded-sm by elegant, light gray upholstered chairs. Above the table hang three stylish, spherical pendant lights with metal cage shades. The dining area is set against a backdrop of dark walls with vertical wooden slats, creating a sophisticated contrast. A built-in cabinet with a white countertop is visible in the background, displaying decorative objects. The room features warm lighting, lending a cozy and inviting atmosphere to the space. Long, light-colored curtains frame the dining area on both sides, adding a touch of softness to the overall design.",
  },
];

/* Drawer Names */

/* General Drawers */

export const DRAWER_CREATE_NEW = "create-new";

/* Account Setup Specific Drawers */

export const DRAWER_BUSINESS_ACTION = "business-action";
export const DRAWER_BUSINESS_MANAGE_BUSINESS_INFO =
  "business-manage-business-info";
export const DRAWER_BUSINESS_ADD_INDIVIDUAL_INFO =
  "business-add-individual-info";
export const DRAWER_ACCOUNT_SETUP_INVITE_TENANT = "account-setup-invite-tenant";
export const DRAWER_BUSINESS_ADD_BUSINESS_WEBSITE_INFO =
  "business-add-business-website-info";
export const DRAWER_BUSINESS_CONTACT_INFO = "business-contact-info";
export const DRAWER_ACCOUNT_SETTINGS = "account-settings";

export const DRAWER_PEOPLE_ACTION = "people-action";

export const DRAWER_CONTACT = "contact";
export const DRAWER_CONTACT_INFO = "contact-info";

export const DRAWER_DOCUMENT_ADD = "document-add";
export const DRAWER_DOCUMENT_ACTION = "document-action";
export const DRAWER_DOCUMENT_RENAME = "document-rename";

export const DRAWER_PROPERTY_ADD = "property-add";
export const DRAWER_PROPERTY_EDIT = "property-edit";
export const DRAWER_PROPERTY_NOTES = "property-notes";
export const DRAWER_PROPERTY_AMENITIES = "property-amenities";
export const DRAWER_PROPERTY_IMAGE = "property-image";

export const DRAWER_UNIT_ADD = "unit-add";
export const DRAWER_UNIT_EDIT = "unit-edit";
export const DRAWER_UNIT_NOTES = "unit-notes";
export const DRAWER_UNIT_INFORMATION = "unit-information";
export const DRAWER_UNIT_AMENITIES = "unit-amenities";
export const DRAWER_UNIT_APPLIANCES = "unit-appliances";
export const DRAWER_UNIT_COOLING_SYSTEMS = "unit-cooling-systems";
export const DRAWER_UNIT_HEATING_SYSTEMS = "unit-heating-systems";
export const DRAWER_UNIT_FLOOR_COVERINGS = "unit-floor-covering";

export const DRAWER_UNIT_IMAGE = "unit-image";
export const DRAWER_UNIT_UTILITY = "unit-utility";
export const DRAWER_UNIT_MARKETING_DESCRIPTION = "unit-marketing-description";
export const DRAWER_UNIT_MARKETING_CONTACT = "unit-marketing-contact";
export const DRAWER_UNIT_MARKETING = "unit-marketing";
export const DRAWER_UNIT_MARKETING_IMAGES = "unit-marketing-images";

export const DRAWER_NEW_LEASE = "new-lease";

export const DRAWER_LEASE_ADD = "lease-add";
export const DRAWER_LEASE_EDIT_ALL = "lease-edit-all";
export const DRAWER_LEASE_EDIT_STATUS = "lease-edit-status";
export const DRAWER_LEASE_INVITE_CONTACT = "lease-invite-contact";
export const DRAWER_LEASE_INVITE_GUEST = "lease-invite-guest";
export const DRAWER_LEASE_NOTES = "lease-notes";

export const DRAWER_REQUIRED_DOCUMENT_ADD = "required-document-add";

export const DRAWER_MAINTENANCE_REQUEST = "maintenance-request";

export const DRAWER_EXPENSE_ADD = "expense-add";

export const DRAWER_CONDITION_REPORT_ACTION = "condition-report-action";
export const DRAWER_CONDITION_REPORT_ACTION_USER =
  "condition-report-action-user";
export const DRAWER_CONDITION_REPORT_CONFIG = "condition-report-config";
export const DRAWER_CONDITION_REPORT_LEASE_PICKER =
  "condition-report-lease-picker";

/* Payments */

export const DRAWER_PAYMENT_ACTION = "payment-action";
export const DRAWER_PAYMENT_RECORD_PAYMENT = "payment-record-payment";
export const DRAWER_PAYMENT_RECURRING_PAYMENT = "payment-recurring-payment";
export const DRAWER_PAYMENT_ONE_TIME_PAYMENT = "payment-one-time-payment";
export const DRAWER_PAYMENT_SECURITY_DEPOSIT_PAYMENT =
  "payment-security-deposit-payment";
export const DRAWER_PAYMENT_ADD_TENANT_PAYMENT_METHOD =
  "payment-add-tenant-payment-method";
export const DRAWER_PAYMENT_ADD_TENANT_PAYMENT_METHOD_FEEDBACK =
  "payment-add-tenant-payment-method-feedback";
export const DRAWER_PAYMENT_MANAGE_AUTOPAY = "manage-autopay";

/* Accounts */

export const DRAWER_ACCOUNT_ADD = "account-add";
export const DRAWER_ACCOUNT_PAYMENT_ASSIGNMENT = "account-payment-assignment";
export const DRAWER_ACCOUNT_VERIFY_EMAIL = "account-verify-email";

export const DRAWER_PAYMENTS_METHODS_ADD_VENMO =
  "payments-mobile-provider-add-venmo";
export const DRAWER_PAYMENTS_METHODS_ADD_CASH_APP =
  "payments-mobile-provider-add-cash-app";
export const DRAWER_PAYMENTS_METHODS_ADD_ZELLE =
  "payments-mobile-provider-add-zelle";
export const DRAWER_PAYMENTS_METHODS_ADD_MANUAL =
  "payments-manual-provider-add";

export const DRAWER_PAYMENT_DEPOSIT_ACTION = "payment-deposit-action";
export const DRAWER_PAYMENT_REQUEST_SECURITY_DEPOSIT_PAYMENT =
  "payment-request-security-deposit-payment";
export const DRAWER_PAYMENT_RECORD_SECURITY_DEPOSIT_PAYMENT =
  "payment-record-security-deposit-payment";

/* Filters */

export const DRAWER_FILTER_PROPERTIES = "filter-properties";
export const DRAWER_FILTER_EXPENSES = "filter-expenses";
export const DRAWER_FILTER_DOCUMENTS = "filter-documents";
export const DRAWER_FILTER_LEASES = "filter-leases";
export const DRAWER_FILTER_INVOICES = "filter-invoices";
export const DRAWER_FILTER_RECURRING_INVOICES = "filter-recurring-invoices";
export const DRAWER_FILTER_MAINTENANCE_REQUESTS = "filter-maintenance-requests";

/* Feedback */

export const DRAWER_FEEDBACK = "feedback";
